import {
  FETCH_LIST_ALL_MY_DELETED_TASK_REQUEST,
  FETCH_LIST_ALL_MY_DELETED_TASK_SUCCESS,
  FETCH_LIST_ALL_MY_DELETED_TASK_FALUIRE,
} from './listAllMyDeletedTaskListTypes'

const initialState = {
  loading: false,
  allDeletedMyTask: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LIST_ALL_MY_DELETED_TASK_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LIST_ALL_MY_DELETED_TASK_SUCCESS : return {
      ...state,
      allDeletedMyTask: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LIST_ALL_MY_DELETED_TASK_FALUIRE : return {
      ...state,
      loading: false,
      allDeletedMyTask: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
